import React from 'react';

/**
 * What the creator sees for a built mission: its FLOW (backend flow.py) - the goal, what the player will do (with the
 * answer each step expects), and what was adjusted. It's built from the mission's design; to change it, edit the
 * design ("Edit the winning path"). Play-test and Regenerate sit right here.
 */
const LEVEL_ICON = { ok: '✅', warn: '⚠️', error: '⛔' };

export default function MissionFlow({ brief, onPlay, onRegenerate, checklist = [] }) {
  const flow = brief.flow;
  if (!flow) return null;
  const factOf = (key) => flow.facts.find((f) => f.key === key);
  const problems = checklist.filter((c) => c.level !== 'ok');

  return (
    <div className="gb-flow">
      {flow.goal && <p className="gb-flow-goal"><strong>Goal:</strong> {flow.goal}</p>}

      <section className="gb-panel">
        <h4>The player will</h4>
        <ol className="gb-flow-steps">
          {flow.steps.map((s) => (
            <li key={s.n}>
              <span className="gb-flow-item">{s.item}</span> {s.does}
              {s.expects && factOf(s.expects) && (
                <span className="gb-flow-answer">→ {String(factOf(s.expects).value)}{factOf(s.expects).unit ? ` ${factOf(s.expects).unit}` : ''}</span>
              )}
            </li>
          ))}
        </ol>
      </section>

      {flow.mistakes.length > 0 && (
        <section className="gb-panel">
          <h4>If they get it wrong</h4>
          <ul>{flow.mistakes.map((m) => <li key={m.key}><span>{m.when}</span>{m.line ? `: ${m.line}` : ''}</li>)}</ul>
        </section>
      )}

      {(flow.notes || []).length > 0 && (
        <section className="gb-panel gb-panel-warn">
          <h4>Added for you</h4>
          <ul>{flow.notes.map((n) => <li key={n}>{n}</li>)}</ul>
        </section>
      )}

      {problems.length > 0 && (
        <ul className="gb-checklist">{problems.map((c) => <li key={`${c.id}-${c.text}`} className={`is-${c.level}`}>{LEVEL_ICON[c.level]} {c.text}</li>)}</ul>
      )}
      <div className="gb-actions">
        {onPlay && <button type="button" className="gb-btn" onClick={onPlay}>▶ Play-test</button>}
        {onRegenerate && <button type="button" className="gb-btn gb-btn-quiet" onClick={onRegenerate}>Regenerate</button>}
      </div>
    </div>
  );
}
